<template>
  <div class="ts-space-y-4">
    <div class="ts-grid ts-grid-cols-2 ts-gap-2">
      <p class="ts-text-right ts-mb-0">{{ $t('gameSetResult.gameSettingName') + ' : ' }}</p>
      <p class="ts-mb-0">
        <span class="ts-text-red-600 ts-font-semibold">{{ gameinput.game_setting_name }}</span>
      </p>
      <p class="ts-text-right ts-mb-0">{{ $t('gameSetResult.drawTime') + ' : ' }}</p>
      <p class="ts-mb-0">
        <span class="ts-text-red-600 ts-font-semibold">{{ gameinput.draw_time }}</span>
      </p>
    </div>
    <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3 ts-mt-4 ts-pb-5">
      <div class="ts-flex ts-space-x-4 ts-mx-auto" style="width:fit-content">
        <input
          v-for="(result, index) in model.result_number"
          :key="index"
          v-model="result.value"
          type="number"
          class="ts-text-center ts-font-semibold ts-text-base ts-border-b-2 ts-px-2 ts-py-1 ts-outline-none ts-w-12"
          :class="errors.has('result_number.' + index + '.value') ? 'ts-border-red-600' : 'ts-border-blue-600'"
          @input="validate($event, result)"
        />
      </div>
    </div>
    <div class="ts-flex ts-justify-end ts-space-x-4">
      <ts-button @click.prevent="$emit('close')" >{{ $t('cancel') }}</ts-button>
      <ts-button color="primary" @click.prevent="onSave">{{ $t('save') }}</ts-button>
    </div>
  </div>
</template>

<script>
import pwdConfirm from './confirm'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'inputResult',
  props: ['gameinput'],
  components: {
    pwdConfirm
  },
  data() {
    return {
      errors:  new Errors(),
      model: {
        password: null,
        game_set_id: null,
        game_type_id: null,
        result_number: []
      }
    }
  },
  created() {
    this.initialData(this.gameinput)
  },
  methods: {
    ...mapActions('administrator/gameSetResult', ['store']),
    onSave() {
      this.errors = new Errors()
      this.$confirm({
        title: null,
        content: h =>
          h(pwdConfirm, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('gameSetResult.password')
            }
          }),
        zIndex: 1025,
        centered: true,
        okText: this.$t('confirm'),
        icon: 'success',
        onOk: () => {
          return this.store(this.model)
            .then(response => {
              this.$toasted.success(response.message)
              this.$emit('close')
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    initialData(value) {
      this.model.game_set_id = value.game_set_id
      this.model.game_type_id = value.game_type_id
      this.model.result_number = []
      let count = value.game_type_id == 2 ? 4 : 5
      for (var i = 0; i <= count; i++) {
        this.model.result_number.push({
          value: null
        })
      }
    },
    validate(e, record){
      let value = e.target.value

      if(this.model.game_type_id == 2){ // 5d
          if(value.length > 1){ // allow input one digit
            record.value = value.substring(0, 1);
          }
      }
      if(this.model.game_type_id == 1){  // 4/49
          if(value.length > 2){ // allow input one digit
            record.value = value.substring(0, 2);
          }
      }
    }
  },
  watch: {
    gameinput: {
      handler(value) {
        this.initialData(value)
      },
      deep: true,
      immediately: true
    }
  }
}
</script>

<style lang="css" scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>